
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCoachPlayersCategoriesListIndex} from "@/models/app/coach/players/categories/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachPlayersCategoriesListFormCreateIndexVue from "@/views/app/coach/players/categories/list/form/create.vue";
import AppCoachPlayersCategoriesListFormUpdateIndexVue from "@/views/app/coach/players/categories/list/form/update.vue";
import AppCoachPlayersCategoriesListFormRemoveIndexVue from "@/views/app/coach/players/categories/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppCoachPlayersCategoriesListFormCreateIndexVue,
    AppCoachPlayersCategoriesListFormUpdateIndexVue,
    AppCoachPlayersCategoriesListFormRemoveIndexVue,
  },
})
export default class AppCoachPlayersCategoriesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  playerCategories: Array<AppCoachPlayersCategoriesListIndex> = [];

  async getPlayerCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/player-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.playerCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getPlayerCategories();
  }
}
